<div class="sidenav-menu">

    <a routerLink="/" class="logo">
        <span class="logo logo-light">
          <span class="logo-lg"><img src="assets/images/logo.png" alt="logo"></span>
          <span class="logo-sm"><img src="assets/images/logo-sm.png" alt="small logo"></span>
        </span>

        <span class="logo logo-dark">
          <span class="logo-lg"><img src="assets/images/logo-big.png" alt="dark logo"></span>
          <span class="logo-sm"><img src="assets/images/logo-sm.png" alt="small logo"></span>
        </span>
    </a>

    <!-- Sidebar Hover Menu Toggle Button -->
    <button (click)="hoverSidebar()" class="button-on-hover">
        <ng-icon name="tablerMenu4" size="22" class="align-middle"/>
    </button>

    <!-- Offcanvas Sidebar Menu Close Button -->
    <button (click)="closeSidebar()" class="button-close-offcanvas">
        <ng-icon name="tablerX" class="align-middle"/>
    </button>

    <ngx-simplebar id="sidenav" class="scrollbar">
        <!--- Sidenav Menu -->
        <app-menu/>
    </ngx-simplebar>
</div>
